<template>
  <div class="home-page">
    <!-- Banner 区域 -->
    <div class="banner">
      <div class="banner_box">
        <img src="https://images.yifucj.com/null/2026/03/19/2ff7809e-d49c-451a-86b8-fb9fbfc7dff2.jpg" width="1080" height="380" alt=""/>
        <div class="banner_text">
          <h1>碧琢网络 · 企业数字化服务商</h1>
          <p>专业网站建设 | 代理记账 | 企业管理咨询 | 技术支持</p>
        </div>
      </div>
    </div>
    
    <!-- 公司资质信息条 -->
    <div class="qualification-bar">
      <div class="container">
        <div class="qual-item">
          <span class="label">公司全称：</span>
          <span>杭州碧琢网络科技有限公司</span>
        </div>
        <div class="qual-item">
          <span class="label">成立时间：</span>
          <span>2015年</span>
        </div>
        <div class="qual-item">
          <span class="label">注册资本：</span>
          <span>100万元</span>
        </div>
        <div class="qual-item">
          <span class="label">统一信用代码：</span>
          <span>91330104MA27W3RD87</span>
        </div>
      </div>
    </div>

    <!-- 业务区域 -->
    <div class="yw">
      <div class="section-title">
        <h2>核心业务</h2>
        <p>为企业提供一站式数字化解决方案</p>
      </div>
      <ul>
        <li>
          <img src="https://images.yifucj.com/null/2026/03/19/654b0412-80c5-47e4-931b-b3713565b33f.png" width="100" height="114" alt=""/>
          <div class="tit">高端网站建设</div>
          <p>多年网站建设经验，专业网站建设，<br/>为您提供一站式系统化的服务</p>
        </li>
        <li>
          <img src="https://images.yifucj.com/null/2026/03/19/15d08949-a6ea-40a7-aa03-e7c4f9701a6b.png" width="100" height="114" alt=""/>
          <div class="tit">代理记账</div>
          <p>流畅移动浏览体验，精美页面设计<br/>多种交互助力移动营销</p>
        </li>
        <li>
          <img src="https://images.yifucj.com/null/2026/03/19/ccfb6007-645b-4239-81f7-5aae51df4ae9.png" width="100" height="114" alt=""/>
          <div class="tit">企业管理</div>
          <p>生成桌面图标，抢占入口<br/>强化企业品牌，引导客户</p>
        </li>
        <li>
          <img src="https://images.yifucj.com/null/2026/03/19/fdd4afc5-c7b4-4cc1-a74d-651cc24549f3.png" width="100" height="114" alt=""/>
          <div class="tit">技术支持</div>
          <p>微信网站无缝对接，<br/>超强微信营销功能</p>
        </li>
      </ul>
    </div>

    <!-- 公司优势 / 服务流程 -->
    <div class="advantage">
      <div class="section-title">
        <h2>我们的优势</h2>
        <p>专业团队 · 高效服务 · 值得信赖</p>
      </div>
      <div class="advantage-list">
        <div class="advantage-item">
          <div class="advantage-icon">✓</div>
          <h3>专业团队</h3>
          <p>资深技术团队，多年行业经验</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-icon">✓</div>
          <h3>资质齐全</h3>
          <p>持有合法经营许可证，合规运营</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-icon">✓</div>
          <h3>服务保障</h3>
          <p>7×24小时技术支持，快速响应</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-icon">✓</div>
          <h3>客户认可</h3>
          <p>服务1000+企业客户，好评率98%</p>
        </div>
      </div>
    </div>

    <!-- 资质荣誉 -->
    <!-- <div class="honor">
      <div class="section-title">
        <h2>资质荣誉</h2>
        <p>合法经营 · 专业认证</p>
      </div>
      <div class="honor-list">
        <div class="honor-item">
          <div class="honor-placeholder"></div>
          <p>营业执照</p>
        </div>
        <div class="honor-item">
          <div class="honor-placeholder"></div>
          <p>增值电信业务经营许可证</p>
        </div>
        <div class="honor-item">
          <div class="honor-placeholder"></div>
          <p>代理记账许可证</p>
        </div>
        <div class="honor-item">
          <div class="honor-placeholder"></div>
          <p>ISO9001认证</p>
        </div>
      </div>
    </div> -->
    
    <!-- 内容区域 -->
    <div class="con">
      <div class="ggjs">
        <div class="bz_tit">
          <router-link to="/about" class="more">查看更多&gt;&gt;</router-link>
          <p class="f18">关于我们</p>
        </div>
        <p>碧琢网络专注于企业管理咨询、技术支持和财税代理记账服务。我们为企业提供财税申报、系统维护等一站式解决方案，助力企业优化运营、降低风险、提升效率。秉承诚信专业、精益求精的理念，做企业值得信赖的伙伴。</p>
      </div>
      
      <div class="sszx">
        <div class="bz_tit">
          <p class="f18">信息资讯</p>
        </div>
        <ul>
          <li>
            <div class="xhd"></div>
            <router-link to="/news">网页设计的优化原则和外链发布</router-link>
          </li>
          <li>
            <div class="xhd"></div>
            <router-link to="/news1">影响网站安全一般有哪些因素？</router-link>
          </li>
          <li>
            <div class="xhd"></div>
            <router-link to="/news2">利用访客分析来进行网页设计</router-link>
          </li>
          <li>
            <div class="xhd"></div>
            <router-link to="/news3">云服务器租用与服务器托管相比有什么优势</router-link>
          </li>
          <li>
            <div class="xhd"></div>
            <router-link to="/news4">短视频+直播+电商模式已悄然到来</router-link>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
      
      <div class="zxal">
        <div class="bz_tit">
          <p class="f18">最新案例</p>
        </div>
        <div class="zxal_img">
            <router-link to="/case">
            <img src="https://images.yifucj.com/null/2026/03/19/831c1ecc-8693-4a5d-8e86-9fc655bf5d33.jpg" width="350" height="70" alt=""/>
            </router-link>
        </div>
        <div class="img_shadow"></div>
        <div class="zxal_img">
            <img src="https://images.yifucj.com/null/2026/03/19/58237846-7d3c-430b-a771-5c553e722f3c.jpg" width="350" height="70" alt=""/>
        </div>
        <div class="img_shadow"></div>
      </div>
      <div class="clear"></div>
    </div>

    <!-- 联系我们 -->
    <div class="contact">
      <div class="section-title">
        <h2>联系我们</h2>
        <p>期待与您合作，共创未来</p>
      </div>
      <div class="contact-content">
        <div class="contact-info">
          <div class="contact-item">
            <span class="contact-icon">📍</span>
            <span>浙江省杭州市上城区恒祺商务中心3幢1107</span>
          </div>
          <div class="contact-item">
            <span class="contact-icon">📞</span>
            <span>服务热线：18057806199</span>
          </div>
          <div class="contact-item">
            <span class="contact-icon">✉️</span>
            <span>电子邮箱：dingfanfan@yifucj.com</span>
          </div>
          <div class="contact-item">
            <span class="contact-icon">🕐</span>
            <span>工作时间：周一至周五 8:30-17:00</span>
          </div>
        </div>
        <div class="contact-form">
          <input type="text" placeholder="您的姓名" v-model="formName">
          <input type="tel" placeholder="联系电话" v-model="formPhone">
          <textarea placeholder="留言内容" rows="3" v-model="formMessage"></textarea>
          <button @click="submitMessage">提交咨询</button>
        </div>
      </div>
    </div>

    <hr>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formName: '',
      formPhone: '',
      formMessage: ''
    }
  },
  mounted() {
    // 页面加载完成后的逻辑
    console.log('首页加载完成')
  },
  methods: {
    submitMessage() {
      if (!this.formName || !this.formPhone|| !this.formMessage) {
        alert('请填写姓名和联系电话和留言内容')
        return
      }
      alert('留言已提交，我们会尽快联系您！')
      this.formName = ''
      this.formPhone = ''
      this.formMessage = ''
    }
  }
}
</script>

<style lang="less" scoped>
@charset "utf-8";

/* CSS Document */
ul, li {
  list-style: none outside none;
  margin: 0;
  padding: 0;
}

div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, form, fieldset, p, blockquote, th, td, ol, ul, li, img {
  margin: 0;
  padding: 0;
  border: 0;
  list-style: none outside none;
}

img {
  border: 0 none;
  margin: 0;
  padding: 0;
  display: block;
}

label, input, button, select, textarea {
  vertical-align: middle;
  outline: medium none;
}

.clear {
  clear: both;
  margin: 0;
  padding: 0;
}

.clearFix:after {
  clear: both;
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
}

.clearFix {
  display: inline-block;
}

a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #e43a3d;
}

body {
  margin: 0;
  font-size: 14px;
  color: #666;
  font-family: "Microsoft Yahei", "微软雅黑", "Arial";
  background: #f8f8f8;
}

.f18 {
  font-size: 18px;
  float: left;
  width: 100px;
  display: block;
}

.home-page {
  width: 100%;
  min-width: 1200px;
  background: #f8f8f8;
}

/* Banner 样式 */
.banner {
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  background: #0f1731;
}

.banner_box {
  width: 1200px;
  height: 380px;
  overflow: hidden;
  margin: 0 auto;
  text-align: center;
  position: relative;
}

.banner_box img {
  width: 100%;
  height: auto;
}

.banner_text {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.banner_text h1 {
  font-size: 32px;
  margin-bottom: 10px;
}

.banner_text p {
  font-size: 16px;
}

/* 资质信息条 */
.qualification-bar {
  background: #f0f2f5;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;
}

.qualification-bar .container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.qualification-bar .qual-item {
  font-size: 13px;
  color: #333;
}

.qualification-bar .qual-item .label {
  font-weight: bold;
  color: #e43a3d;
}

/* 通用标题样式 */
.section-title {
  text-align: center;
  padding: 40px 0 20px;
}

.section-title h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
  position: relative;
  display: inline-block;
  padding-bottom: 10px;
}

.section-title p {
  color: #999;
  font-size: 14px;
}

/* 业务区域样式 */
.yw {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.yw ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.yw li {
  padding: 50px 30px;
  display: block;
  overflow: hidden;
  transition: all 0.3s ease;
}

.yw li:hover {
  background: #f0f0f0;
}

.yw li .tit {
  font-size: 20px;
  color: #323234;
  padding: 15px 0;
  font-weight: 500;
}

.yw li p {
  color: #96969a;
  line-height: 1.5;
  font-size: 14px;
}

/* 优势区域 */
.advantage {
  background: #fff;
  padding: 20px 0 50px;
}

.advantage .advantage-list {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.advantage .advantage-list .advantage-item {
  width: 260px;
  text-align: center;
  padding: 30px 20px;
  background: #f8f8f8;
  border-radius: 8px;
  transition: all 0.3s;
}

.advantage .advantage-list .advantage-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
}

.advantage .advantage-list .advantage-item .advantage-icon {
  width: 60px;
  height: 60px;
  line-height: 60px;
  background: #e43a3d;
  color: #fff;
  font-size: 30px;
  border-radius: 50%;
  margin: 0 auto 20px;
}

.advantage .advantage-list .advantage-item h3 {
  font-size: 18px;
  margin-bottom: 10px;
}

.advantage .advantage-list .advantage-item p {
  color: #999;
  font-size: 14px;
}

/* 资质荣誉 */
.honor {
  background: #f8f8f8;
  padding: 20px 0 50px;
}

.honor .honor-list {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.honor .honor-list .honor-item {
  width: 260px;
  text-align: center;
}

.honor .honor-list .honor-item .honor-placeholder {
  height: 180px;
  background: #e0e0e0;
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  background: #ddd;
}

.honor .honor-list .honor-item p {
  font-weight: bold;
}

/* 内容区域样式 */
.con {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;
}

.ggjs {
  width: 320px;
  background: #fff;
  padding: 50px;
  box-sizing: border-box;
  float: left;
}

.ggjs p {
  line-height: 25px;
  font-size: 14px;
  color: #666;
}

.bz_tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding-bottom: 20px;
  overflow: hidden;
  position: relative;
}

.bz_tit .more {
  float: right;
  font-size: 14px;
  color: #d3253e;
  width: 80px;
  height: 30px;
  text-align: right;
}

.sszx {
  width: 320px;
  overflow: hidden;
  background: #ececec;
  padding: 10px;
  box-sizing: border-box;
  float: left;
}

.sszx ul {
  width: 100%;
}

.sszx li {
  width: 100%;
  padding: 0 5px;
  height: 40px;
  display: flex;
  align-items: center;
  line-height: 40px;
  overflow: hidden;
  cursor: pointer;
}

.sszx li:hover {
  background: #f5f5f5;
}

.sszx li a {
  display: block;
  padding-left: 5px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.xhd {
  background: #d3253e;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  display: inline-block;
  margin-right: 10px;
  flex-shrink: 0;
}

.zxal {
  background: #e6e6e6;
  width: 380px;
  padding: 60px 10px;
  box-sizing: border-box;
  float: left;
}

.zxal_img {
  width: 350px;
  height: 70px;
  overflow: hidden;
  margin-bottom: 10px;
}

.zxal_img a {
  display: block;
  width: 100%;
  height: 100%;
}

.zxal_img a:hover {
  opacity: 0.8;
}

.zxal_img img {
  width: 100%;
  height: auto;
}

.img_shadow {
  height: 0;
}

/* 联系我们 */
.contact {
  background: #fff;
  padding: 20px 0 50px;
}

.contact .contact-content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.contact .contact-content .contact-info {
  width: 45%;
}

.contact .contact-content .contact-info .contact-item {
  padding: 12px 0;
  font-size: 16px;
  border-bottom: 1px dashed #eee;
}

.contact .contact-content .contact-info .contact-item .contact-icon {
  display: inline-block;
  width: 30px;
  color: #e43a3d;
}

.contact .contact-content .contact-form {
  width: 45%;
}

.contact .contact-content .contact-form input,
.contact .contact-content .contact-form textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.contact .contact-content .contact-form button {
  background: #e43a3d;
  color: #fff;
  border: none;
  padding: 10px 30px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.contact .contact-content .contact-form button:hover {
  background: #c61420;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .home-page {
    min-width: 100%;
  }
  
  .banner {
    min-width: 100%;
  }
  
  .banner_box {
    width: 100%;
  }
  
  .banner_box img {
    width: 100%;
    height: auto;
  }
  
  .yw, .con {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  
  .yw ul {
    justify-content: center;
  }
  
  .con {
    flex-wrap: wrap;
  }
  
  .ggjs, .sszx, .zxal {
    width: 32%;
    margin-bottom: 20px;
  }
  
  .qualification-bar .container,
  .advantage .advantage-list,
  .honor .honor-list,
  .contact .contact-content {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    flex-wrap: wrap;
  }
  
  .advantage .advantage-list .advantage-item,
  .honor .honor-list .honor-item {
    width: 48%;
    margin-bottom: 20px;
  }
  
  .contact .contact-info,
  .contact .contact-form {
    width: 100% !important;
    margin-bottom: 30px;
  }
}

@media (max-width: 768px) {
  .yw li {
    width: 50%;
    padding: 30px 20px;
  }
  
  .ggjs, .sszx, .zxal {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .advantage .advantage-list .advantage-item,
  .honor .honor-list .honor-item {
    width: 100%;
  }
  
  .zxal_img {
    width: 100%;
    height: auto;
  }
  
  .zxal_img img {
    width: 100%;
    height: auto;
  }
}
</style>